import { UserRole } from '@mairistem/finances-utils';
import { createContext } from 'react';

const SessionContext = createContext({ userRole: UserRole.NORMAL });

export default SessionContext;
